import React, { Component } from 'react';
import './report-page.component.css';
import TopVendors from './cost-report/topVendors.component';
import TopCountries from './cost-report/topCountries.component';
// import CostDistribution from './cost-report/cost-distribution.component';
import { CostDistribution } from './cost-report/cost-distribution/cost-distribution.component';
import { CostReportFilter } from './cost-report/cost-report-filter.component';

class CostReportPage extends Component {

    render() {
        return (
            <div>
                <div className="container-mt-7 report-main-container">
                    <CostReportFilter />
                    <CostDistribution />
                    <div className="subcomponent"> 
                        <TopVendors />
                        <TopCountries />
                    </div>
                </div>
            </div>
        )
    }

}

export default CostReportPage;